export interface User {
  id: number;
  firstName: string;
  lastName: string;
  emailAddress: string;
  password: string;
  oneTimePassword: string;
  mobileNumber: string;
  referredByRep: string;
  userName: string;
  CompanyName: string;
}
